<template>
	<div>
		<b-modal size="sm" ref="showMobileReceipt">
			<template #modal-title>
				<span class="akkurate-green fw-bold akkurate-extra-small">
					{{
						(report_data?.selectedGlCode || report_data?.user_glCode) ? "OTHER" : (
							report_data?.transaction_mode +
							" " +
							report_data?.transaction_type
						).toLocaleUpperCase()
					}}
					RECEIPT</span>
			</template>
			<div style="color: black;" class="row akkurate-dark akkurate-extra-small" ref="pdfContent">
				<div class="col">
					<div class="col-12 w-100 d-flex justify-content-between">
						<img width="50px" class="img-fluid img-visibility" style="margin-right: 1rem" :src="require('@/assets/img/default_logo.png')" />
						<div>
							<p class="fw-bold mb-0">
								{{ report_data.institution?.name }}
							</p>
							<p class="mb-0 fw-bold">
								{{ report_data.institution?.address }}
							</p>
							<p class="mb-0 fw-bold">
								TEL: {{ report_data.institution?.telephone }}
							</p>
						</div>
					</div>
					<div class="d-flex justify-content-between w-100">
						<p class="mb-0 fw-bold">
							{{ report_data?.user_glCode ? "OTHER" : report_data?.transaction_type }}
							RECEIPT
						</p>
						<p class="mb-0 fw-bold">
							RECEIPT NO: {{ report_data?.receipt_no }}
						</p>
					</div>
				</div>
				<hr class="m-0 mb-1" />
				<div class="col-12">
					<p v-if="report_data?.user_glCode" class="fw-bold mb-0 w-100">
						GL CODE: {{ report_data?.user_glCode }}
					</p>
					<p v-else class="fw-bold mb-0 w-100">
						CUSTOMER CODE: {{ report_data?.customer_code }}
					</p>

					<p v-if="report_data.user_glName" class="fw-bold mb-0 w-100">
						GL NAME: {{ report_data?.user_glName }}
					</p>
					<p v-else class="fw-bold mb-0 w-100">
						CUSTOMER NAME: {{ report_data?.fullname }}
					</p>
					<b-table-simple bordered small style="margin-top: 0.5rem; color: black !important;" class="m-0">
						<b-tbody>
							<b-tr v-if="report_data?.selectedGlCode">
								<td class="fw-bold" style="color: black !important;">SELECTED GL CODE</td>
								<td style="color: black !important;" class="fw-bold">{{ report_data?.selectedGlCode }} ~ {{ report_data.selectedGlNote }}</td>
							</b-tr>
							<b-tr v-else>
								<td class="fw-bold" style="color: black !important;">ACC. NUMBER</td>
								<td style="color: black !important;" class="fw-bold">{{ report_data?.account_number }}</td>
							</b-tr>
							<b-tr v-if="report_data?.loan_number">
								<td class="fw-bold" style="color: black !important;">LOAN NUMBER</td>
								<td style="color: black !important;" class="fw-bold">{{ report_data?.loan_number }}</td>
							</b-tr>
							<b-tr v-if="report_data.selectedGlName">
								<b-td class="fw-bold" style="color: black !important;">SELECTED GL NAME: </b-td>
								<b-td style="color: black !important;" class="fw-bold">{{ report_data?.selectedGlName }}</b-td>
							</b-tr>
							<b-tr v-else>
								<b-td class="fw-bold" style="color: black !important;">PRODUCT: </b-td>
								<b-td style="color: black !important;" class="fw-bold">{{ report_data?.product }}</b-td>
							</b-tr>
							<b-tr>
								<td class="fw-bold" style="color: black !important;">AMOUNT</td>
								<td style="color: black !important;" class="fw-bold">
									{{
										report_data?.institution?.currency_code
									}}
									{{ displayNumber(report_data?.amount) }}
								</td>
							</b-tr>
							<b-tr>
								<td class="fw-bold" style="color: black !important;">TELLER NAME</td>
								<td style="color: black !important;" class="fw-bold">
									{{ report_data?.teller }} - {{ report_data.teller_id }}
								</td>
							</b-tr>

							<b-tr>
								<td class="fw-bold" style="color: black !important;">DATE:</td>
								<td style="color: black !important;" class="fw-bold">{{ formatDate(report_data?.trans_date) }}</td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</div>
				<hr class="mt-1 mb-1" />
				<div class="w-100 d-flex flex-row justify-content-between align-items-md-center px-4">
					<div>
						<div class="text-start text-center fw-bold">Teller's Sign.</div>
						<div class="text-start mt-4">___________________</div>
						<div class="text-start text-center fw-bold">
							{{ report_data?.teller }}
						</div>
					</div>
					<div>
						<div class="text-start text-center fw-bold">
							Customer's Sign
						</div>
						<div class="text-start mt-4">__________________</div>
						<div class="text-start text-center fw-bold">
							Signature and Date
						</div>
					</div>
				</div>
			</div>
			<template #modal-footer>
				<div class="w-100">
					<b-button @click="generatePDF" type="button" class="akkurate-green-btn download-btn ms-2 float-right"><span class="small"><font-awesome-icon :icon="['fas', 'book']" />
							Print</span></b-button>
					<b-button @click="exportToPDF" class="akkurate-green-btn download-btn float-right"><span class="small"><font-awesome-icon :icon="['fas', 'save']" />
							Download</span></b-button>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
	props: ["report_data"],
	methods: {
		showModal() {
			console.log("Report Data:", this.report_data);
			this.$refs["showMobileReceipt"].show();
		},
		hideModal() {
			this.$refs["showMobileReceipt"].hide();
		},
		exportToPDF() {
			const originalContent = this.$refs.pdfContent;

			if (!originalContent) {
				console.error("PDF content not found.");
				return;
			}

			const content = originalContent.cloneNode(true);
			content.classList.add("akkurate-extra-extra-small");
			content.style.height = "auto";

			const height = this.pxToMm(
				originalContent.height || originalContent.offsetHeight
			);

			const ins = this.report_data?.institution || {};

			// Creating and appending footer
			const footer = document.createElement("div");
			footer.style.textAlign = "center";
			footer.classList.add("mt-2");
			footer.classList.add("akkurate-extra-very-small");
			footer.innerHTML = `
						<p class="akkurate-extra-very-small" style="margin: 0; padding: 0;">For Inquiries, Please Contact <strong>${ins.name}</strong>, Customer Service on ${ins.telephone} or email us on ${ins.email} </p>
						<p class="akkurate-extra-very-small" style="margin: 0; padding: 0;">${ins.motto}</p>
						<p class="akkurate-extra-very-small" style="margin-top: 2px; padding: 0;">Page 1 of 1</p>
						`;
			// <p class="mb-0" style="margin-top: 1rem;">Page 1 of 1</p>
			content.appendChild(footer);

			const pdfOptions = {
				margin: [1, 1, 1, 1],
				filename: "receipt.pdf",
				image: { type: "jpeg", quality: 0.75 },
				html2canvas: {
					scale: 10,
					useCORS: true,
					logging: false,
					allowTaint: false,
				},
				jsPDF: {
					unit: "mm",
					format: [57, height > 65 ? height + 15 : 65],
					orientation: "portrait",
				},
			};

			this.$nextTick(() => {
				html2pdf()
					.from(content)
					.set(pdfOptions)
					.toPdf()
					.get("pdf")
					.then((pdf) => {
						return pdf.output("blob");
					})
					.save()
					.catch((error) => {
						console.error("Error generating PDF:", error);
					});
			});
		},
		generatePDF() {
			const originalContent = this.$refs.pdfContent;

			if (!originalContent) {
				console.error("PDF content not found.");
				return;
			}

			const content = originalContent.cloneNode(true);
			content.classList.add("akkurate-extra-extra-small");

			const height = this.pxToMm(
				originalContent.height || originalContent.offsetHeight
			);

			const ins = this.report_data?.institution || {};

			// Creating and appending footer
			const footer = document.createElement("div");
			footer.style.textAlign = "center";
			footer.classList.add("mt-2");
			footer.classList.add("akkurate-extra-very-small");
			footer.innerHTML = `
						<p class="akkurate-extra-very-small" style="margin: 0; padding: 0;">For Inquiries, Please Contact <strong>${ins.name}</strong>, Customer Service on ${ins.telephone} or email us on ${ins.email} </p>
						<p class="akkurate-extra-very-small" style="margin: 0; padding: 0;">${ins.motto}</p>
						<p class="akkurate-extra-very-small" style="margin-top: 2px; padding: 0;">Page 1 of 1</p>
						`;
			// <p class="mb-0" style="margin-top: 1rem;">Page 1 of 1</p>
			content.appendChild(footer);

			const pdfOptions = {
				margin: [1, 1, 1, 1],
				filename: "receipt.pdf",
				image: { type: "jpeg", quality: 0.75 },
				html2canvas: {
					scale: 10,
					useCORS: true,
					logging: false,
					allowTaint: false,
				},
				jsPDF: {
					unit: "mm",
					format: [57, height > 65 ? height + 15 : 65],
					orientation: "portrait",
				},
			};

			this.$nextTick(() => {
				html2pdf()
					.from(content)
					.set(pdfOptions)
					.toPdf()
					.get("pdf")
					.then((pdf) => {
						;
						return pdf.output("blob");
					})
					.then((pdfBlob) => {
						const pdfUrl = URL.createObjectURL(pdfBlob);

						const printWindow = window.open(
							pdfUrl,
							"_blank",
							"width=800,height=600"
						);

						printWindow.onload = () => {
							printWindow.print();
							URL.revokeObjectURL(pdfUrl);
						};
					})
					.catch((error) => {
						console.error("Error generating PDF:", error);
					});
			});
		},
		pxToMm(px) {
			return (px * 25.4) / 96;
		},
	},
};
</script>

<style scoped>
@media print {
	[ref="pdfContent"] {
		width: 57mm !important;
	}

	img {
		max-width: 100% !important;
		height: auto !important;
	}
}

.receipt-modal {
	width: 57mm !important;
	max-width: 57mm !important;
	min-height: 37mm !important;
	margin: 0 auto;
	padding: 0;
}
</style>